import {
  IReview,
  getReviews,
  getReview,
} from "containers/SocialMediaDetailsContainer/lib/http";
import * as _ from "lodash";
import * as React from "react";
import { GridContainer } from "components/ui/Grid";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  Row
} from 'reactstrap';
import { INote, getNotes, addNote, deleteNote } from "./lib/http";
import { DataGrid } from "components/ui/DataGrid";
import { ModalContent } from "components/ui/Modal";

interface ISocialMediaCoachingFormProps {
  id: number;
}

interface ISocialMediaCoachingFormState {
  review: IReview;
  notes: INote[];
  modalOpen: boolean;
  submitting: boolean;
  message: string;
  errorMessage: string;
}

export class SocialMediaCoachingForm extends React.Component<
  ISocialMediaCoachingFormProps,
  ISocialMediaCoachingFormState
> {
  state: ISocialMediaCoachingFormState = {
    review: undefined,
    notes: [],
    modalOpen: false,
    submitting: false,
    message: "",
    errorMessage: "",
  };

  componentDidMount() {
    getReview(this.props.id).then((review) => this.setState({ review }));
    getNotes(this.props.id).then((notes) => this.setState({ notes }));
  }

  toggleModal() {
    const { modalOpen } = this.state;

    this.setState({ modalOpen: !modalOpen });
  }

  renderStars(numberOfStars: number) {
    const starsHtml = [];
    for (let i = 1; i < 6; i++) {
      if (numberOfStars >= i) {
        starsHtml.push(
          <span style={{ color: "gold", fontSize: "20px" }}>★</span>
        );
      } else {
        starsHtml.push(
          <span style={{ color: "#212121", fontSize: "20px" }}>★</span>
        );
      }
    }

    return (
      <>
        {starsHtml.map((icon, index) => (
          <span key={`star-` + index}>{icon}</span>
        ))}
      </>
    );
  }

  submit(e) {
    const { id } = this.props;
    const { message, modalOpen } = this.state;
    e.preventDefault();

    this.setState({ submitting: true });

    if ("" === message) {
      this.setState({
        submitting: false,
        errorMessage: "Message may not be empty",
      });
      return;
    } else {
      this.setState({ errorMessage: "" });
    }

    addNote(id, message).then((notes) => {
      this.setState({
        notes,
        modalOpen: !modalOpen,
        submitting: false,
        message: "",
      });
    });
  }

  confirmDeleteNote(noteId) {
    const { id } = this.props;
    if (confirm("Are you sure you want to delete this note?")) {
      deleteNote(noteId, id).then((notes) => this.setState({ notes }));
    }
  }

  render() {
    const { review } = this.state;
    const entityName = "Main Street Branch";

    return (
      <article>
        <GridContainer className="blacklight">
          <Card>
            <Row className="mb-4 p-2">
              <Col sm={12} md={6}>
                <img
                  id="logo"
                  className="responsive-img"
                  src="images/logos/avannis_logo.png?v=3"
                  alt="Avannis Reporting"
                />
              </Col>
              <Col sm={12} md={6}>
                <h5 className="mt-4 mr-2 float-right text-right">
                  <p style={{ lineHeight: "1.0rem" }}>
                    {review && review.locationName}
                    <small>
                      <br />
                      {review && review.address}
                      <br />
                      {review && review.city}, {review && review.state}&nbsp;
                      {review && review.zipcode}
                    </small>
                  </p>
                  <p style={{ lineHeight: "0.7rem" }}>
                    {review && review.platform}
                  </p>
                </h5>
              </Col>
            </Row>
          </Card>
          <Card>
            <CardHeader>
              <h3>Review</h3>
            </CardHeader>
            <CardBody>
              <p>{review ? review.reviewrProfilePhotoUrl : ""}</p>
              <p>{review ? review.reviewerName : ""}</p>
              <p>
                {review ? this.renderStars(review.starRating) : ""}
                <span className="ml-4">{review ? review.createTime : ""}</span>
              </p>
              <p>{review ? review.comment : ""}</p>
              {review && review.replyComment && review.replyComment.length > 0 && (
                <section
                  className="ml-5 px-3"
                  style={{ borderLeft: "2px solid #a1a1a1" }}
                >
                  <p>
                    <b>Response from the owner</b>
                    <small className="ml-2">
                      {review ? review.replyTime : ""}
                    </small>
                  </p>
                  <p>{review ? review.replyComment : ""}</p>
                </section>
              )}
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <h3>
                Notes
                <a
                  className="btn btn-primary float-right text-white"
                  onClick={() => this.toggleModal()}
                >
                  Add Note
                </a>
              </h3>
            </CardHeader>
            <CardBody>
              {this.state.notes && this.state.notes.length === 0 && (
                <Alert color="warning">
                  No alerts have been added to this coaching form.
                </Alert>
              )}
              {this.state.notes && this.state.notes.length > 0 && (
                <DataGrid
                  records={this.state.notes}
                  columns={[
                    { header: "Comment Date", property: "createTime" },
                    { header: "User", property: "username" },
                    { header: "Message", property: "message" },
                    {
                      header: "Delete?",
                      render: (record) => (
                        <a
                          className="btn btn-destructive text-white"
                          onClick={() => this.confirmDeleteNote(record.id)}
                        >
                          Delete
                        </a>
                      ),
                    },
                  ]}
                />
              )}
            </CardBody>
          </Card>
        </GridContainer>
        <Modal
          wrapClassName="blacklight"
          modalClassName="blacklight-modal"
          isOpen={this.state.modalOpen}
          toggle={() => this.toggleModal()}
        >
          <Form onSubmit={(e) => this.submit(e)}>
            <ModalHeader>Add Note</ModalHeader>
            <ModalContent className="p-3">
              <FormGroup>
                <Label>
                  Message&nbsp;
                  <small style={{ color: "red" }}>
                    {this.state.errorMessage ? this.state.errorMessage : ""}
                  </small>
                </Label>
                <textarea
                  value={this.state.message}
                  onChange={(e) => this.setState({ message: e.target.value })}
                ></textarea>
              </FormGroup>
            </ModalContent>
            <ModalFooter>
              <Button
                type="button"
                color="white"
                onClick={() => this.toggleModal()}
              >
                <span>Cancel</span>
              </Button>
              <Button type="submit" color="danger">
                {this.state.submitting ? (
                  <i key="Submitting" className="fas fa-cog fa-spin fa-fw" />
                ) : (
                  <i key="AddNote" className="fas fa-plus fa-fw" />
                )}
                <span>&nbsp;Add</span>
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </article>
    );
  }
}
